import React, { Component } from 'react';
class DetailSupplier extends Component{
    render(){
        return (<div className="p-grid">
            Đang cập nhật
        </div>)
    }
}

export default DetailSupplier;